<template>
  <div>
    <div v-if="productsStore.section.parameters?.listView !== 'post'" class="row products-navigation">
      <div class="col-xs-6">
        <span class="products-quantity">
          <!--				{{ productsData.countText }}-->
        </span>
      </div>
      <div class="col-xs-6 text-right">
        <div class="pull-right">
          <div class="btn-group">
            <a
              class="btn btn-primary"
              href="#"
              @click.prevent="localCurrent.viewStyle = 'grid'"
              :class="{ active: localCurrent.viewStyle === 'grid' }"
            >
              <span class="glyphicon glyphicon-th-large"></span>
            </a>
            <a
              class="btn btn-primary"
              href="#"
              @click.prevent="localCurrent.viewStyle = 'table'"
              :class="{ active: localCurrent.viewStyle === 'table' }"
            >
              <span class="glyphicon glyphicon-list-alt"></span>
            </a>
            <a
              class="btn btn-primary"
              href="#"
              @click.prevent="localCurrent.viewStyle = 'list'"
              :class="{ active: localCurrent.viewStyle === 'list' }"
            >
              <span class="glyphicon glyphicon-th-list"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div :class="'view-' + localCurrent.viewStyle" class="ng-cloak">
      <div v-if="localCurrent.viewStyle !== 'table'">
        <div ref="containerRef1">
          <div
            v-for="(product, index) in props.products"
            :key="index"
            class="product-item"
          >
            <span @click="goto(product.url)" style="cursor: pointer" class="thumbnail">
              <div class="product-image img-overlay img-overlay-container">
                <div class="overlay main-btn">
                  <div class="btn btn-default" v-if="product.url">
                    <span>
                      {{ productsStore.section.button_caption || 'Details' }}
                    </span>
                  </div>
                </div>

                <img
                  v-if="product.image && localCurrent.viewStyle === 'grid'"
                  :alt="product.image.alt || product.title"
                  :title="product.image.title || product.title"
                  class="img-responsive"
                  :src="imageUrl(product.image, productsStore.section.imageTypes.grid)"
                />

                <img
                  v-if="product.image && localCurrent.viewStyle === 'list'"
                  :alt="product.image.alt || product.title"
                  :title="product.image.title || product.title"
                  class="img-responsive"
                  :src="imageUrl(product.image, productsStore.section.imageTypes.list)"
                />

                <img
                  v-if="!product.image && productsStore.section.settings.section_placeholder"
                  :alt="product.image?.alt || product.title"
                  :title="product.image?.title || product.title"
                  class="img-responsive img-width-100"
                  :src="getImageUrl(productsStore.section.settings.section_placeholder, productsStore.section.imageTypes.list)"
                />

                <img
                  v-else-if="!product.image"
                  class="img-responsive"
                  style="width: 100%;"
                  src="../assets/no_image_big.png"
                />
              </div>

              <div class="product-info">
                <div class="product-title tooltipped tooltipped-n" :aria-label="product.title">
                  <span class="text-ellipsis h3">{{ product.title }}</span>
                </div>
                <div class="product-attributes-container">
                  <div class="product-attributes">
                    <!--                  <dl-->
                    <!--                      v-if="attribute.value !== null"-->
                    <!--                      class="attribute"-->
                    <!--                      :data-bz-attribute="attribute"-->
                    <!--                      :icon-url="imageUrl(attribute.icon[0], '')"-->
                    <!--                  ></dl>-->
                    <product-info
                      v-for="attribute in product.attributes"
                      :key="attribute.id"
                      :icon-url="imageUrl(attribute.icon[0], '')"
                      :attribute="attribute">
                    </product-info>
                    <div class="btn btn-primary visible-xs visible-sm btn-details">
                      <span>
                        {{ productsStore.section.button_caption || 'Details' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
            </span>
          </div>

          <div class="col-xs-12 text-center" v-if="loading">
            Loading data...
            <br/>
            <br/>
          </div>
          <div
            class="col-xs-12"
            v-if="!loaded && current.infiniteScrollDisabled && productsData.nextText"
          >
            <a
              href="#"
              class="btn btn-primary btn-block"
              @click.prevent="loadMore"
              v-text="productsData.nextText"
            ></a>
          </div>
        </div>
      </div>

      <div  ref="containerRef2" v-if="localCurrent.viewStyle === 'table'">
        <div>
          <table class="table table-striped table-hover" v-if="products.length">
            <tbody>
              <tr class="table-head">
                <th class="cell-title">&nbsp;</th>
                <th
                  v-for="attr in products[0].attributes"
                  :key="attr.id"
                  class="cell-attribute hidden-sm hidden-xs"
                >
                  <div class="tooltipped tooltipped-n" :aria-label="attr.title">
                    <span class="text-ellipsis">{{ attr.title }}</span>
                  </div>
                </th>
                <th class="cell-image hidden-sm hidden-xs"></th>
              </tr>
              <tr
                v-for="(product, index) in products"
                :key="index"
                @click="goto(product.url)"
              >
                <td class="cell-title">
                  <div class="tooltipped tooltipped-n" :aria-label="product.title">
                    <strong class="text-ellipsis">{{ product.title }}</strong>
                  </div>
                  <div class="product-info visible-sm visible-xs">
                    <product-info v-for="attribute in product.attributes" :key="attribute.id"
                                  :icon-url="imageUrl(attribute.icon[0], '')" :attribute="attribute"/>
                  </div>
                </td>
                <td
                  v-for="attribute in product.attributes"
                  :key="attribute.id"
                  class="cell-attribute attribute hidden-sm hidden-xs"
                >
                  <product-info
                    :icon-url="imageUrl(attribute.icon[0], '')"
                    :attribute="attribute"
                    :show-title="false"
                  />
                </td>
                <td class="cell-image hidden-sm hidden-xs">
                  <img
                    v-if="product.image"
                    class="img-responsive"
                    :src="imageUrl(product.image, productsStore.section.imageTypes.table)"
                    :alt="product.image.name"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-xs-12 text-center" v-if="loading">
              Loading data...
              <br />
              <br />
            </div>
            <div class="col-xs-12" v-if="!loaded && current.infiniteScrollDisabled">
              <a
                href="#"
                class="btn btn-primary btn-block"
                @click.prevent="loadMore"
                v-text="productsData.nextText"
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, defineProps, computed } from 'vue';
import ProductInfo from "@/components/ProductInfo.vue";
import { useProductsStore } from '@/stores/products';
import { useInfiniteScroll } from "@/composables/useInfiniteScroll";
import { imageUrl } from "@/utils/imageUrl";
import { getImageUrl } from "@/utils/getImageUrl";
import { useRouter } from 'vue-router';

const props = defineProps({
  products: {
    type: Array,
    required: true,
  }, productsData: {
    type: Object,
    required: true,
  },
});

// Reactive variables
const localCurrent = reactive ({ viewStyle: 'grid' });
const current = reactive ({
  infiniteScrollDisabled: false,
});
const loading = ref(false);
const loaded = computed(() => {
  return productsStore.products.length === productsStore.filteredProducts.length
});

const router = useRouter();

const productsStore = useProductsStore();
const containerRef1 = ref(null);
const containerRef2 = ref(null);

function loadMore() {
  productsStore.addPage();
  productsStore.loadMore();
}

// Function to handle scroll
useInfiniteScroll(containerRef1, !current.infiniteScrollDisabled, () => {
  loadMore()
});

useInfiniteScroll(containerRef2, !current.infiniteScrollDisabled, () => {
  loadMore()
});

function goto (id) {
  router.push(`${id}`);
}

function verifyImageUrl(url, fallbackUrl) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(url); // Resolve with original URL if it loads successfully
    img.onerror = () => resolve(fallbackUrl); // Resolve with fallback URL if it fails
    img.src = url;
  });
}

</script>

<style scoped lang="scss">
.products-navigation {
  display:block !important;
}
//.table-striped > tbody > tr {
//  background-color: #f9f9f9;
//}
</style>
